import { useState } from "react";
import { subscriptionService, taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { isEmpty } from "@miplatform/utils";

export const useManagerApprovalModalViewModel = () => {
  const [reasons, setReasons] = useState([]);
  const [managers, setManagers] = useState([]);

  const getReasons = async (attemptTypeId) => {
    const response = await taskService.attemptTypes.getApproveReasons({
      attemptTypeId,
    });

    if (response.status === HTTP_STATUSES.OK) {
      const { data } = response;

      const result = data.map(({ reason }) => ({
        label: reason,
        value: reason,
      }));

      setReasons(isEmpty(result) ? [{ label: "None", value: "None" }] : result);
    }
  };

  const getManagerWithPermissionToOverwrite = async (permission) => {
    const response = await subscriptionService.users.listByPermission({
      permission,
    });

    if (response.status === HTTP_STATUSES.OK) {
      const { data } = response;

      const result = data.map(({ displayName, id }) => ({
        label: displayName,
        value: id,
      }));

      setManagers(result);
    }
  };

  return {
    getReasons,
    getManagerWithPermissionToOverwrite,
    managers,
    reasons,
  };
};
